// Optimizely flag keys
export const SplashScreenFlag = 'onboardingVisualRedesignSplashScreen';
export const HomeFeedPersonalizeAlgorithmFlag = 'homePersonalizeFeed';
export const EngagementNavigationExternalLinksFlag = 'engagementNavigationExternalLinks';
export const PartnerEnrollmentEverconnectFlag = 'partnerEnrollmentEverconnect';
export const PublicAccessFlag = 'publicAccess';
export const RecaptchaFlag = 'recaptchas';
export const ServiceNationCommunityLinkFlag = 'serviceNationCommunityLink';
export const MembershipsPageFlag = 'membershipsPage';
export const ServiceNationEventsLinkFlag = 'serviceNationEventsLink';
export const ServiceNationDesignServicesLinkFlag = 'serviceNationDesignServicesLink';
export const ServiceNationOnDemandTrainingLinkFlag = 'serviceNationOnDemandTrainingLink';
export const ServiceNationAdvisoryBoardsLinkFlag = 'serviceNationAdvisoryBoardsLink';
export const IframeSNEventTrainingPageFlag = 'iframeSNEventTrainingPage';
export const IframeSNDesignServicesPageFlag = 'iframeSNDesignServicesPage';
export const SNSettingsLinkFlag = 'SNSettingsLink';
export const ServiceNationWalletFlag = 'serviceNationWallet';
export const OnboardingFlowTestFlag = 'onboardingFlowTest';
export const AiCoachFlag = 'aiCoach';
export const AiCoachBetaAccessFlag = 'aiCoachBetaAccess';
export const RebateMatrixFlag = 'rebateMatrix';
export const UseEdgeHomeForServiceNationUsersFlag = 'useEdgeHomeForServiceNationUsers';
export const EdgeHomeNewDesignFlag = 'edgeHomeNewDesign';
// flag variable names
export const splashScreenVariant = 'splashScreenBannerType';
export const splashScreenImageUrl = 'splashScreenImageUrl';
export const splashScreenHeading = 'splashScreenHeading';
export const splashScreenSubHeading = 'splashScreenSubHeading';
export const splashScreenCtaText = 'splashScreenCtaText';
